module.exports = __webpack_public_path__ + "img/contains_plot.307e3869.png";